import { render, staticRenderFns } from "./employee-profile.vue?vue&type=template&id=05df5fa8"
import script from "./employee-profile.vue?vue&type=script&lang=js"
export * from "./employee-profile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports